// src/features/dashboard/utils/heatmap.utils.ts

export const getColor = (
  value: number | null,
) => {

  if (value === null)
    return '#F8FAFC';

  if (value <= 10)
    return '#DCFCE7';

  if (value <= 20)
    return '#BBF7D0';

  if (value <= 30)
    return '#86EFAC';

  if (value <= 40)
    return '#4ADE80';

  if (value <= 50)
    return '#22C55E';

  return '#15803D';
};